module.exports = __webpack_public_path__ + "img/vpn-5.56dfccf0.jpg";